import dayjs from "dayjs"

export class SaleEventModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new SaleEventModel(), obj)

    newObj.startDate = obj.startDate ? dayjs(obj.startDate) : null
    newObj.endDate = obj.endDate ? dayjs(obj.endDate) : null
    newObj.validDate = obj.validDate ? dayjs(obj.validDate) : null

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
